"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
/**
* @export
* @enum {string}
*/
var TableauSemanticsFieldConceptDataTypesEnum;
(function (TableauSemanticsFieldConceptDataTypesEnum) {
    TableauSemanticsFieldConceptDataTypesEnum["DataTypeUnspecified"] = "DATA_TYPE_UNSPECIFIED";
    TableauSemanticsFieldConceptDataTypesEnum["Date"] = "DATE";
    TableauSemanticsFieldConceptDataTypesEnum["Datetime"] = "DATETIME";
    TableauSemanticsFieldConceptDataTypesEnum["String"] = "STRING";
    TableauSemanticsFieldConceptDataTypesEnum["Int"] = "INT";
    TableauSemanticsFieldConceptDataTypesEnum["Float"] = "FLOAT";
    TableauSemanticsFieldConceptDataTypesEnum["Bool"] = "BOOL";
})(TableauSemanticsFieldConceptDataTypesEnum = exports.TableauSemanticsFieldConceptDataTypesEnum || (exports.TableauSemanticsFieldConceptDataTypesEnum = {})); /**
* @export
* @enum {string}
*/
var TableauSemanticsFieldConceptFieldRolesEnum;
(function (TableauSemanticsFieldConceptFieldRolesEnum) {
    TableauSemanticsFieldConceptFieldRolesEnum["FieldRoleUnspecified"] = "FIELD_ROLE_UNSPECIFIED";
    TableauSemanticsFieldConceptFieldRolesEnum["Dimension"] = "DIMENSION";
    TableauSemanticsFieldConceptFieldRolesEnum["Measure"] = "MEASURE";
})(TableauSemanticsFieldConceptFieldRolesEnum = exports.TableauSemanticsFieldConceptFieldRolesEnum || (exports.TableauSemanticsFieldConceptFieldRolesEnum = {}));
function TableauSemanticsFieldConceptFromJSON(json) {
    return TableauSemanticsFieldConceptFromJSONTyped(json, false);
}
exports.TableauSemanticsFieldConceptFromJSON = TableauSemanticsFieldConceptFromJSON;
function TableauSemanticsFieldConceptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'uri': !runtime_1.exists(json, 'uri') ? undefined : json['uri'],
        'objectConceptUri': !runtime_1.exists(json, 'object_concept_uri') ? undefined : json['object_concept_uri'],
        'names': !runtime_1.exists(json, 'names') ? undefined : (json['names'].map(_1.TableauSemanticsNameFromJSON)),
        'nameCharacteristics': !runtime_1.exists(json, 'name_characteristics') ? undefined : _1.TableauSemanticsNameCharacteristicsFromJSON(json['name_characteristics']),
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'parentFieldConceptUri': !runtime_1.exists(json, 'parent_field_concept_uri') ? undefined : json['parent_field_concept_uri'],
        'dataTypes': !runtime_1.exists(json, 'data_types') ? undefined : json['data_types'],
        'fieldRoles': !runtime_1.exists(json, 'field_roles') ? undefined : json['field_roles'],
        'defaultFormats': !runtime_1.exists(json, 'default_formats') ? undefined : json['default_formats'],
        'valueCharacteristics': !runtime_1.exists(json, 'value_characteristics') ? undefined : _1.TableauSemanticsValueCharacteristicsFromJSON(json['value_characteristics']),
        'ownerId': !runtime_1.exists(json, 'owner_id') ? undefined : json['owner_id'],
        'createdAt': !runtime_1.exists(json, 'created_at') ? undefined : json['created_at'],
        'updatedAt': !runtime_1.exists(json, 'updated_at') ? undefined : json['updated_at'],
        'valueSource': !runtime_1.exists(json, 'value_source') ? undefined : _1.TableauSemanticsValueSourceFromJSON(json['value_source']),
        'dataRoleId': !runtime_1.exists(json, 'data_role_id') ? undefined : json['data_role_id'],
        'key': !runtime_1.exists(json, 'key') ? undefined : json['key'],
    };
}
exports.TableauSemanticsFieldConceptFromJSONTyped = TableauSemanticsFieldConceptFromJSONTyped;
function TableauSemanticsFieldConceptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'uri': value.uri,
        'object_concept_uri': value.objectConceptUri,
        'names': value.names === undefined ? undefined : (value.names.map(_1.TableauSemanticsNameToJSON)),
        'name_characteristics': _1.TableauSemanticsNameCharacteristicsToJSON(value.nameCharacteristics),
        'description': value.description,
        'parent_field_concept_uri': value.parentFieldConceptUri,
        'data_types': value.dataTypes,
        'field_roles': value.fieldRoles,
        'default_formats': value.defaultFormats,
        'value_characteristics': _1.TableauSemanticsValueCharacteristicsToJSON(value.valueCharacteristics),
        'owner_id': value.ownerId,
        'created_at': value.createdAt,
        'updated_at': value.updatedAt,
        'value_source': _1.TableauSemanticsValueSourceToJSON(value.valueSource),
        'data_role_id': value.dataRoleId,
        'key': value.key,
    };
}
exports.TableauSemanticsFieldConceptToJSON = TableauSemanticsFieldConceptToJSON;
